import { render, staticRenderFns } from "./LicencesManagerPage.vue?vue&type=template&id=23d9e5f2&scoped=true"
import script from "./LicencesManagerPage.vue?vue&type=script&lang=js"
export * from "./LicencesManagerPage.vue?vue&type=script&lang=js"
import style0 from "./LicencesManagerPage.vue?vue&type=style&index=0&id=23d9e5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9e5f2",
  null
  
)

export default component.exports